import { Loader2 } from 'lucide-react';

interface PaneLoaderProps {
  message?: string;
}

/**
 * Loading skeleton displayed while a pane is being lazy loaded.
 */
export const PaneLoader = ({ message = 'Loading...' }: PaneLoaderProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-8">
      {/* Animated loader */}
      <div className="relative">
        <div className="w-16 h-16 bg-gradient-to-br from-coral-100 to-coral-50 rounded-2xl flex items-center justify-center shadow-sm">
          <Loader2 className="w-8 h-8 text-coral-500 animate-spin" />
        </div>
      </div>

      {/* Loading text */}
      <p className="mt-4 text-sm font-medium text-neutral-500">{message}</p>

      {/* Skeleton content preview */}
      <div className="mt-8 w-full max-w-2xl space-y-4">
        {/* Header skeleton */}
        <div className="h-8 bg-neutral-200/50 rounded-lg w-1/3 animate-pulse" />

        {/* Content skeletons */}
        <div className="grid grid-cols-3 gap-4">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="h-32 bg-neutral-200/50 rounded-xl animate-pulse"
              style={{ animationDelay: `${i * 100}ms` }}
            />
          ))}
        </div>

        {/* List skeleton */}
        <div className="space-y-2 mt-6">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="h-12 bg-neutral-200/50 rounded-lg animate-pulse"
              style={{ animationDelay: `${i * 50}ms` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
